import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.9998 14.25V12.25M11.9977 21.0358L14.7377 18.7657C14.9171 18.6171 15.1427 18.5358 15.3757 18.5358L18.002 18.5358C19.1065 18.5357 20.002 17.6403 20.002 16.5358V6.5C20.002 5.39543 19.1065 4.5 18.0019 4.5L6.00195 4.50002C4.89738 4.50002 4.00195 5.39545 4.00195 6.50002V16.5358C4.00195 17.6403 4.89738 18.5358 6.00195 18.5358H8.65157C8.8865 18.5358 9.11393 18.6185 9.29398 18.7694L11.9977 21.0358Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 9.25H12.01M12.25 9.25C12.25 9.38807 12.1381 9.5 12 9.5C11.8619 9.5 11.75 9.38807 11.75 9.25C11.75 9.11193 11.8619 9 12 9C12.1381 9 12.25 9.11193 12.25 9.25Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }